import { render, staticRenderFns } from "./email-creation-modal.vue?vue&type=template&id=5c1d312b&scoped=true&"
import script from "./email-creation-modal.vue?vue&type=script&lang=js&"
export * from "./email-creation-modal.vue?vue&type=script&lang=js&"
import style0 from "./email-creation-modal.vue?vue&type=style&index=0&id=5c1d312b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1d312b",
  null
  
)

export default component.exports